module.exports = __webpack_public_path__ + "img/client-4.19537ca9.jpg";